/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Breadcrumbs, Typography } from '@material-ui/core';
import { Link, useHistory, useLocation } from 'react-router-dom';
import React from 'react';
import _ from 'lodash';
import { useLinkStyles } from './useLinkStyles';

const BreadcrumbComp = ({ className, currentBreadcrumb }) => {
  const history = useHistory();
  const location = useLocation();
  const linkClass = useLinkStyles();

  if (location?.state?.length === 0) {
    return null;
  }
  return (
    <Breadcrumbs aria-label="breadcrumb" className={className}>
      {location?.state?.map((stateItem, index) => {
        return (
          <Link
            key={index}
            className={linkClass.link}
            onClick={() => history.go(index - location.state.length)}
            to={null}
          >
            <Typography>{stateItem.goBackText}</Typography>
          </Link>
        );
      })}
      {currentBreadcrumb && <Typography>{currentBreadcrumb}</Typography>}
    </Breadcrumbs>
  );
};

function propsAreEqual(prevProps, nextProps) {
  return _.isEqual(prevProps.currentBreadcrumb, nextProps.currentBreadcrumb);
}

const Breadcrumb = React.memo(BreadcrumbComp, propsAreEqual);

export default Breadcrumb;
